import { getDNQStateByAbbreviationOrName } from '../data/dnqStates'

export function isDNQState(state: string) {
  const dnqState = getDNQStateByAbbreviationOrName(state)
  return !!dnqState
}
